<script setup lang="ts">
import {useCarousel} from './useCarousel'
import CarouselButton from "./CarouselButton.vue";
import {tw} from "../../../utils/tailwind";
import type {HTMLAttributes} from "vue";

interface Props{
    svgClasses?: string|null|undefined
    class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
    svgClasses: "lg:!h-15 lg:!w-15",
})

const {orientation, canScrollPrev, scrollPrev, arrowColor, hoverArrowColor, outline, outlineColor} = useCarousel()
const strokeWidth = outline ? '0.6' : 0;
</script>

<template>
    <CarouselButton
        :disabled="!canScrollPrev"
        :class="tw(
      'touch-manipulation absolute',
      orientation === 'horizontal'
        ? 'left-4 top-1/2 -translate-y-1/2 lg:-left-12'
        : '-top-12 left-1/2 -translate-x-1/2 rotate-90',
      props.class,
    )"
        variant="outline"
        @click="scrollPrev"
    >
        <slot>
            <div class="absolute group carouselNav" :style="'--hover-color:' + hoverArrowColor">
                <svg viewBox="0 0 36 38" xmlns="http://www.w3.org/2000/svg" :fill="arrowColor"
                     class="!w-7 !h-7" :class="svgClasses">
                    <path d="M35 10.5V1L1 15V22.5L35 37V27L15.5 19L35 10.5Z" :stroke-width="strokeWidth" :stroke="outlineColor"/>
                </svg>
                <span class="sr-only">Previous Slide</span>
            </div>
        </slot>
    </CarouselButton>
</template>
